<template>
  <s-modal
    v-model="showModal"
    size="lg"
    ok-only
    :ok-title="$t('actions.close')"
    title=""
    @ok="closeModal"
    :html="true"
  >
    <b-container>
      <b-row class="align-items-center title">
        <b-col class="d-flex align-items-center">
          <i class="fas fa-info-circle informationIcon mb-4"></i>
          <h1 class="mb-4 ml-4">{{ $t('fields.asset.subtype-modal.title') }}</h1>
        </b-col>
      </b-row>

      <s-table :fields="fields" :items="items" class="mb-3 subtype-table">
        <template #cell(subtype)="data">
          <strong>{{ data.item.subtype }}</strong>
        </template>
        <template #cell(description)="data">
          <span>{{ data.item.description }}</span>
        </template>
      </s-table>

      <div class="reference-row">
        <div class="reference-row__label">
          {{ $t('fields.asset.subtype-modal.reference-column') }}
        </div>
        <div class="reference-row__desc">
          {{ $t('fields.asset.subtype-modal.reference-description') }}
        </div>
      </div>
    </b-container>
  </s-modal>
</template>

<script>
import translate from '@/services/translate';

export default {
  name: 'SubtypeHelpModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showModal: false,
    fields: [
      {
        key: 'subtype',
        label: translate('fields.asset.subtype-modal.subtype-column'),
        class: 'text-left',
      },
      {
        key: 'description',
        label: translate('fields.asset.subtype-modal.description-column'),
        class: 'text-left',
      },
    ],
    items: [
      {
        subtype: translate('fields.asset.subtype-modal.learning-column'),
        description: translate('fields.asset.subtype-modal.learning-description'),
      },
      {
        subtype: translate('fields.asset.subtype-modal.orphan-column'),
        description: translate('fields.asset.subtype-modal.orphan-description'),
      },
      {
        subtype: translate('fields.asset.subtype-modal.ordinary-column'),
        description: translate('fields.asset.subtype-modal.ordinary-description'),
      },
    ],
  }),
  watch: {
    value: {
      handler(val) {
        this.showModal = val;
      },
      immediate: true,
    },
    showModal(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.informationIcon
  font-size: 1.5em
  margin-left: 10px

.subtype-table
  border: 1px solid var(--color-table-header-bg) !important
  border-radius: 5px !important

  ::v-deep th:nth-child(1),
  ::v-deep td:nth-child(1)
    min-width: 109.69px !important
    max-width: 109.69px !important

  ::v-deep th,
  ::v-deep td
    text-align: left !important
    border: 3px solid var(--color-background-light) !important
    vertical-align: middle !important
    color: var(--color-text) !important
    background-color: var(--color-background) !important

  ::v-deep th
    background-color: var(--color-table-header-bg) !important
    font-size: 1.1em
    font-weight: bold

.reference-row
  display: grid
  grid-template-columns: minmax(109.69px, auto) 1fr
  margin: -3px 0 1rem
  border-radius: 0 0 5px 5px
  margin-bottom: 1rem
  background-color: var(--color-table-header-bg) !important

.reference-row__label
  background-color: var(--color-table-header-bg) !important
  padding: 1rem
  font-weight: bold
  display: flex
  align-items: center
  color: var(--color-text-secondary) !important

.reference-row__desc
  padding: 1rem
  border-left: 3px solid var(--color-background-light)
  color: var(--color-text) !important
  background-color: var(--color-table-row-bg) !important
</style>
<style>
.modal-footer {
  margin-right: 15px !important;
  margin-bottom: 15px !important;
}
</style>
